export var RequestStatus = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["Idle"] = "idle";
    RequestStatus["Fetching"] = "fetching";
    RequestStatus["Error"] = "error";
    return RequestStatus;
}({});

//# sourceMappingURL=types.js.map